function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "145.648,61.339 144.648,72.099 133.889,100.825 131.221,102.381 129.118,113.475 126.232,116.027  129.34,119.801 128.34,149.194 132.561,175.371 127.011,188.686 129.893,190.01 132.003,199.668 130.117,200 123.128,192.789  120.242,191.678 118.579,193.897 94.175,194.781 82.196,192.563 79.312,185.023 73.543,182.25 73.99,185.579 58.792,179.811  58.234,174.041 60.678,173.151 58.014,165.17 55.683,165.723 54.58,158.513 60.678,157.184 60.678,148.305 63.781,143.312  68.772,144.2 71.104,141.983 74.54,141.65 69.773,126.231 70.103,116.251 67.219,115.143 78.983,106.046 83.413,105.484  85.301,96.064 88.743,96.614 106.268,82.417 106.268,80.198 101.831,79.87 100.83,61.122 94.733,60.229 91.847,62.448  89.186,58.899 83.973,59.118 75.101,42.039 75.874,38.929 68.552,37.051 70.328,30.39 66.116,27.621 67.994,24.623 65.112,9.98  61.12,5.323 65.337,0 73.543,7.98 76.646,26.278 80.867,32.059 83.752,41.484 88.966,48.139 96.62,50.361 98.727,53.133  111.041,57.458 111.814,59.452 123.907,59.118 139.324,66.108 "
});

var Svg28 = function Svg28(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TAM",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg28, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/28.5ac87957.svg";
export { ForwardRef as ReactComponent };